import styled from '@emotion/styled';
import { QuestionCircleFilled } from '@ant-design/icons';

export const CardContainer = styled.div`
  background-color: ${props => props.theme.color.secondary};
  border-radius: 16px;
  box-shadow: 0 3px 8px ${props => props.theme.color.primary}33;
  color: ${props => props.theme.color.primary};
  display: flex;
  flex-direction: column;
  height: 100%;
  justify-content: space-between;
  padding: ${props => props.theme.spacing.regular} ${props => props.theme.spacing.regular};
  text-align: center;
`;

export const SummaryLabel = styled.p`
  font-size: 16px;
  margin-bottom: 0;
`;

export const TooltipIcon = styled(QuestionCircleFilled)`
  color: ${props => props.theme.color.primary};
`;
